import { Navigate, Route, Routes } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import { ParkingDetails, ParkingEvents } from '../pages'
import Login from '../pages/login/login'
import Site from '../pages/site/site'
import UserDetails from '../pages/userDetails/userDetails'
import Whitelist from '../pages/whitelist/whitelist'
import MoovyRoute from './moovyRoute'
import { appRoutes, hasPermission } from './permissions'

const MoovyRouters = () => {
  const { isAuthenticated, isAdmin, isReady } = useAuth()
  const RouteHome = () => {
    const showLoginRoute = !isAuthenticated && isReady
    return showLoginRoute ? (
      <Login />
    ) : (
      <Navigate to={appRoutes.PARKING_EVENTS} />
    )
  }

  return (
    <Routes>
      <Route
        index
        element={
          <MoovyRoute>
            <RouteHome />
          </MoovyRoute>
        }
      />
      <Route
        path={appRoutes.USER_DETAILS}
        element={
          <MoovyRoute
            isAllowed={
              isAuthenticated && hasPermission(isAdmin, 'READ', 'USER_DETAILS')
            }
            isProgress={!isReady}
          />
        }
      >
        <Route index element={<UserDetails />} />
      </Route>
      <Route
        path={appRoutes.PARKING_EVENTS}
        element={
          <MoovyRoute
            isAllowed={
              isAuthenticated &&
              hasPermission(isAdmin, 'READ', 'PARKING_EVENTS')
            }
            isProgress={!isReady}
          />
        }
      >
        <Route index element={<ParkingEvents />} />
        <Route path=":parkingEventRef" element={<ParkingDetails />} />
      </Route>
      <Route
        path={appRoutes.WHITELIST}
        element={
          <MoovyRoute
            isAllowed={
              isAuthenticated && hasPermission(isAdmin, 'READ', 'WHITELIST')
            }
            isProgress={!isReady}
          />
        }
      >
        <Route index element={<Whitelist />} />
        <Route path=":whitelistedVehicleRef" element={<Whitelist />} />
      </Route>
      <Route
        path={appRoutes.SITE}
        index
        element={
          <MoovyRoute
            isAllowed={
              isAuthenticated && hasPermission(isAdmin, 'READ', 'SITE')
            }
            isProgress={!isReady}
          >
            <Site />
          </MoovyRoute>
        }
      />
    </Routes>
  )
}

export default MoovyRouters
